import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const deleteCompany = async (companyId: string): Promise<boolean> =>
  axios.delete(`/management/company/removecompany?companyId=${companyId}`).then((res) => res?.data?.result)

type Props = {
  companyId: string
}

export const useManagementDeleteCompany = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['deleteCompany'],
    mutationFn: ({ companyId }: Props) => deleteCompany(companyId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Deleted company.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to delete company, please try again.')
      }
    },
    throwOnError: false
  })
